/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Italian (it) string table · skin-concerns.html
   English is the source of truth in the HTML; this file supplies the
   Italian counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-it.js.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.it = window.TD_I18N.it || {};
  Object.assign(window.TD_I18N.it, {

    /* ── Page header ── */
    'concerns.headLabel': 'Trova la tua formula',
    'concerns.headTitle': 'Inizia da ciò che<br><em>ti dà fastidio.</em>',
    'concerns.headSub': 'Cinque sieri, cinque obiettivi biologici. Inizia dal bisogno che conta di più per te e, quasi sempre, il siero giusto si sceglie da solo.',

    /* ── Jump bar ── */
    'concerns.jumpLabel': 'Vai a',
    'concerns.jumpFirmness': 'Compattezza',
    'concerns.jumpBrightness': 'Luminosità',
    'concerns.jumpHydration': 'Idratazione',
    'concerns.jumpFineLines': 'Linee sottili',
    'concerns.jumpDarkSpots': 'Macchie scure',
    'concerns.jumpTexture': 'Texture',
    'concerns.jumpAcneScars': 'Cicatrici da acne',
    'concerns.jumpDullness': 'Pelle spenta',

    /* ── Reusable row labels ── */
    'concerns.startWith': 'Inizia con',
    'concerns.shopRoutine': 'Compra questa routine →',
    'concerns.nameC': 'Serum C — <em>Luminosità</em>',
    'concerns.nameA': 'Serum A — <em>Rinnovamento</em>',
    'concerns.nameO': 'Serum O — <em>Cellulare</em>',
    'concerns.nameM': 'Serum M — <em>Idratazione</em>',
    'concerns.nameR': 'Serum R — <em>Chiarezza</em>',
    'concerns.rolePrimaryDay': 'Principale · Giorno',
    'concerns.rolePrimaryNight': 'Principale · Notte',
    'concerns.rolePrimaryDayNight': 'Principale · Giorno + Notte',
    'concerns.roleLayerDay': 'Strato · Giorno',
    'concerns.roleLayerNight': 'Strato · Notte',

    /* ── Concern 01 · Firmness ── */
    'concerns.c1Num': 'Bisogno 01',
    'concerns.c1Title': 'Compattezza<br><em>& elasticità.</em>',
    'concerns.c1Lede': 'La linea della mascella si ammorbidisce. Gli zigomi perdono il loro sostegno. La pelle inizia a cedere invece di tenere. È il primo segno visibile che la produzione di collagene ed elastina è rallentata, e il più semplice da invertire a livello cellulare.',

    /* ── Concern 02 · Brightness ── */
    'concerns.c2Num': 'Bisogno 02',
    'concerns.c2Title': 'Luminosità<br><em>& danni solari.</em>',
    'concerns.c2Lede': 'La pelle appare opaca anche quando tu non lo sei. Spesso è cumulativo: UV, inquinamento, stress, energia cellulare ridotta. La vitamina C è l\'ingrediente topico più studiato per la luminosità. Serum O va oltre e alimenta direttamente i mitocondri, le cellule che producono energia.',

    /* ── Concern 03 · Hydration ── */
    'concerns.c3Num': 'Bisogno 03',
    'concerns.c3Title': 'Disidratazione<br><em>& perdita della barriera.</em>',
    'concerns.c3Lede': 'La pelle secca non è una questione di più crema idratante. È una questione di barriera lipidica rotta. La maggior parte delle creme idratanti è 65-85% acqua più alcol e conservanti, il che paradossalmente disidrata ulteriormente la pelle. Serum M ricostruisce la barriera dall\'interno con lipidi identici a quelli della pelle.',

    /* ── Concern 04 · Fine lines ── */
    'concerns.c4Num': 'Bisogno 04',
    'concerns.c4Title': 'Linee sottili<br><em>& rughe.</em>',
    'concerns.c4Lede': 'Linee superficiali da espressione, pieghe più profonde dovute al tempo e al sole. Il rinnovamento cellulare rallenta con l\'età; i vecchi cheratinociti restano più a lungo; la texture ne risente. Il retinolo riavvia il rinnovamento e leviga la superficie; la vitamina C ricostruisce la struttura sottostante.',

    /* ── Concern 05 · Dark spots ── */
    'concerns.c5Num': 'Bisogno 05',
    'concerns.c5Title': 'Macchie scure<br><em>& pigmentazione.</em>',
    'concerns.c5Lede': 'I danni solari, i cambiamenti ormonali e i segni post-infiammatori concentrano il pigmento in macchie irregolari. La vitamina C inibisce l\'enzima (tirosinasi) che guida la produzione di pigmento; il resveratrolo neutralizza i radicali liberi che la innescano.',

    /* ── Concern 06 · Texture ── */
    'concerns.c6Num': 'Bisogno 06',
    'concerns.c6Title': 'Texture<br><em>irregolare.</em>',
    'concerns.c6Lede': 'Zone ruvide, pori visibili, una superficie irregolare su cui il trucco si deposita invece di levigarsi. È quasi sempre un problema di rinnovamento cellulare: vecchie cellule cutanee ispessite che restano più a lungo del dovuto. Il retinolo accelera il ciclo.',

    /* ── Concern 07 · Post-acne ── */
    'concerns.c7Num': 'Bisogno 07',
    'concerns.c7Title': 'Post-acne<br><em>& cicatrici.</em>',
    'concerns.c7Lede': 'Molto dopo che lo sfogo è passato, il segno spesso resta. Il resveratrolo riduce la pigmentazione post-infiammatoria e accompagna la pelle mentre completa la riparazione che ha iniziato. Combina con Serum A di notte per un rinnovamento cellulare che accelera lo schiarimento del segno.',

    /* ── Concern 08 · Dullness / mature ── */
    'concerns.c8Num': 'Bisogno 08',
    'concerns.c8Title': 'Spegnimento <em>&amp; perdita di elasticità.</em>',
    'concerns.c8Lede': 'Con la maturità della pelle, i sistemi che la mantengono luminosa e tonica rallentano. La nitidezza della superficie si attenua e l\'elasticità cede. Serum O rinnova e rivitalizza la pelle matura a livello cellulare, sostenendo la luminosità e la tonicità che diminuiscono con l\'età.',

    /* ── Not sure CTA ── */
    'concerns.unsureLabel': 'Stai ancora scegliendo?',
    'concerns.unsureTitle': 'Non scegliere. Provali tutti e cinque.',
    'concerns.unsureBody': 'Il Discovery Kit include versioni tascabili di ogni siero e una guida stampata. È il modo più rapido per imparare quale dei tuoi bisogni risponde a quale formula: sulla tua pelle, non in teoria.',
    'concerns.unsureBtn': 'Ottieni il Discovery Kit',

    /* ── Footer (page-specific extra) ── */
    'concerns.ftLearnRonlan': 'Sul Dr. Ronlán',

    /* ── Theme-only: Concern 08 alt framing (fatigue / low energy) ── */
    'concerns.c8TitleFatigue': 'Vitalità ridotta<br><em>& energia bassa.</em>',
    'concerns.c8LedeFatigue': 'Una pelle spenta non sempre dipende da ciò che si vede in superficie. Dipende da ciò che la produce. La produzione mitocondriale diminuisce con l\'età, e con essa la capacità della cellula di formare collagene e riparare i danni. Serum O alimenta il sistema direttamente e restituisce energia alle cellule.',

    /* ── Theme-only: application banner (conditional) ── */
    'concerns.appDividerLabel': 'In pratica',
    'concerns.appDividerQuote': 'Due gocce, mattina e sera. La pelle che hai, curata.',

    /* ── Theme-only: shortened unsure body (no printed guide) ── */
    'concerns.unsureBodyShort': 'Il Discovery Kit include versioni tascabili di ogni siero. È il modo più rapido per imparare quale dei tuoi bisogni risponde a quale formula: sulla tua pelle, non in teoria.'

  });
})();
